$(() => {
  $(window).on("load", () => {
    const imagesArray = [];
    const advanceAccordion = $(".bs-section--processors-see-what .bs-advance-accordion");
    if (typeof advanceAccordion != undefined) {
      advanceAccordion.each((ind, ele) => {
        const imageLogo = $(ele).find(".bs-advance-accordion__left-content-panel>.bs-div:first-child .media-elements");
        if (imageLogo) {
          imageLogo.each((logoIndex, logoElement) => {
            const logoImage = $(logoElement).find("img").clone();
            imagesArray.push(logoImage);
          });
        }
        // accordion remove height from each clicked items
        const allPanels = $(ele).find(".bs-advance-accordion__left-content-panel .bs-div:first-child .bs-div__inner");
        const cardsItems = $(ele).find(".bs-advance-accordion__right-container .card");
        if (cardsItems.length != 0) {
          // make first item height same as first tab content
          const firstCard = $(allPanels[0]).innerHeight();
          $(ele)
            .find(".bs-advance-accordion__left-container")
            .css("height", firstCard + 225 + "px");
          // each items clicks
          cardsItems.each((crd, crdItem) => {
            $(crdItem).on("click", (e) => {
              e.preventDefault();
              const cardIndex = $(crdItem).index();
              const logInners = $(allPanels[cardIndex]).innerHeight();
              $(crdItem).addClass("active");
              $(ele)
                .find(".bs-advance-accordion__left-container")
                .css("height", logInners + 225 + "px");
            });
          });
        }
      });
    }
    const accordionMobileBehavior = (deviceWidth) => {
      if (deviceWidth.matches) {
        if (typeof advanceAccordion != undefined) {
          advanceAccordion.each((ind, ele) => {
            $(ele).find(".bs-advance-accordion__right-container .card .card-header span+img").remove();
          });
        }
      } else {
        if (typeof advanceAccordion != undefined) {
          advanceAccordion.each((ind, ele) => {
            const cardHeaders = $(ele).find(".bs-advance-accordion__right-container .card .card-header");
            if (typeof cardHeaders != undefined) {
              cardHeaders.each((cardIndex, cardElement) => {
                cardElement.append(imagesArray[cardIndex][0]);
              });
            }
          });
        }
        if (imagesArray.length != 0) {
          for (let ind = 0; ind < imagesArray.length; ind++) {
            const sectionLogos = imagesArray[ind];
            if (sectionLogos.length != 0) {
            }
          }
        }
      }
    };

    const deviceWidth = window.matchMedia("(max-width: 991px)");
    accordionMobileBehavior(deviceWidth);
    deviceWidth.addEventListener("change", () => {
      accordionMobileBehavior(deviceWidth);
    });
  });
});
